import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import StatistiqueSection from './components/StatistiqueSection';
import ProblematiqueSection from './components/ProblematiqueSection';
import ImpactsSection from './components/ImpactsSection';
import PublicCibleSection from './components/PublicCibleSection';
import SolutionSection from './components/SolutionSection';
import BeneficesSection from './components/BeneficesSection';
import CountdownSection from './components/CountdownSection';
import ResultsTimelineSection from './components/ResultsTimelineSection';
import FAQSection from './components/FAQSection';
import GuaranteeSection from './components/GuaranteeSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import FloatingCTA from './components/FloatingCTA';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF7F4]" style={{ fontFamily: 'Inter, sans-serif' }}>
      {/* Navigation fixe */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <h1 className={`text-xl font-bold transition-colors ${scrolled ? 'text-[#3D2817]' : 'text-[#3D2817]'}`} style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Sophro Cavaliers
            </h1>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#problematique" className={`text-sm font-medium transition-colors hover:text-[#3D2817] ${scrolled ? 'text-gray-700' : 'text-gray-800'}`}>Problématique</a>
            <a href="#solution" className={`text-sm font-medium transition-colors hover:text-[#3D2817] ${scrolled ? 'text-gray-700' : 'text-gray-800'}`}>Solution</a>
            <a href="#benefices" className={`text-sm font-medium transition-colors hover:text-[#3D2817] ${scrolled ? 'text-gray-700' : 'text-gray-800'}`}>Avantages</a>
            <a 
              href="https://sophrocavaliers.learnybox.com/commande-site-2025/" 
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-2.5 bg-[#3D2817] text-white rounded-full text-sm font-medium hover:bg-[#2C1810] transition-all whitespace-nowrap cursor-pointer"
            >
              Réserver ma place
            </a>
          </div>
        </div>
      </nav>

      <HeroSection />
      <CountdownSection />
      <StatistiqueSection />
      <ProblematiqueSection />
      <ImpactsSection />
      <PublicCibleSection />
      <SolutionSection />
      <ResultsTimelineSection />
      <BeneficesSection />
      <GuaranteeSection />
      <FAQSection />
      <CTASection />
      <Footer />
      <FloatingCTA />
    </div>
  );
}